/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { getUpComingDates } from "helper/EventHelper/EventHelper";

import { eventslug, eventMemberRoleSlug } from "Config/Config";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

const ReportBody = () => {
  const token = localStorage.getItem("token");
  const eventId = localStorage.getItem("eventId");

  const reportLimit = 10;

  const [registeredEvents, setregisteredEvents] = useState(0);
  const [agendaCount, setagendaCount] = useState(0);
  const [feedbackCount, setfeedbackCount] = useState(0);

  const [userCount, setuserCount] = useState(0);
  const [sentContactCount, setsentContactCount] = useState(0);
  const [accpetContactCount, setaccpetContactCount] = useState(0);
  const [pendingContactCount, setpendingContactCount] = useState(0);

  const [agendaSentCount, setagendaSentCount] = useState(0);
  const [agendaAccpetCount, setagendaAccpetCount] = useState(0);
  const [agendaPendingCount, setagendaPendingCount] = useState(0);

  const [agendaCustomerCount, setagendaCustomerCount] = useState(0);
  const [agendaProviderCount, setagendaProviderCount] = useState(0);
  const [agendaPartnerCount, setagendaPartnerCount] = useState(0);

  const [memberReportLoading, setMemberReportLoading] = useState(false);
  const [memberReportList, setmemberReportList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [hideLoadMore, setHideLoadMore] = useState(false);

  //get reports
  const getEventReports = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_EVENT_REPORT + `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setregisteredEvents(response.data.registeredeventcount);
        setagendaCount(response.data.eventagendaacount);
        setfeedbackCount(response.data.eventreviewcount);

        setuserCount(response.data.usercount);
        setsentContactCount(response.data.requestsentcount);
        setaccpetContactCount(response.data.requestacceptedcount);
        setpendingContactCount(response.data.requestpendingcount);

        setagendaSentCount(response.data.meetingsentcount);
        setagendaAccpetCount(response.data.meetingacceptedcount);
        setagendaPendingCount(response.data.meetingpendingcount);

        setagendaCustomerCount(response.data.meetingcustomercount);
        setagendaProviderCount(response.data.meetingprovidercount);
        setagendaPartnerCount(response.data.meetingsuppliercount);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get member report
  const getMemberReports = async (start, limit) => {
    setMemberReportLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEMBER_REPORT +
        `?token=${token}&event=${eventId}&roleslug=${eventMemberRoleSlug}&start=${start}&limit=${limit}`;

      const response = await getData(requestUrl);
      setMemberReportLoading(false);

      console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          if (start === 1) {
            setmemberReportList(response.data);
          } else {
            setmemberReportList([...memberReportList, ...response.data]);
          }
        }

        if (response.data.length === reportLimit) {
          setHideLoadMore(false);
        } else {
          setHideLoadMore(true);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //click load more button
  const onNextPage = () => {
    setPageNo(pageNo + 1);
  };

  const refreshHandler = () => {
    setPageNo(1);
    getEventReports();
    // getMemberReports(1, reportLimit);
  };

  useEffect(() => {
    if (pageNo) {
      getMemberReports(pageNo, reportLimit);
    }
  }, [pageNo]);

  useEffect(() => {
    getEventReports();
  }, []);

  return (
    <section className="inner_sec">
      <div className="container">
        <div className="page_heading mb-3">
          <h1 className="position-relative pb-4 text-uppercase">REPORT</h1>
        </div>

        <div className="d-flex justify-content-end align-items-center mb-5">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary me-2"
            onClick={refreshHandler}
          >
            <span className="material-icons-outlined text-white">refresh</span>
          </Link>
        </div>

        {/* total event basis report */}
        <div className="report_outer">
          <div className="row">
            {/* event count */}
            <div className="col-lg-3 col-sm-6 mb-3">
              <div className="report_bx bg_white p-4">
                <div className="speaker_info">
                  <h3 className="mb-3">Events</h3>
                  <div className="report_table_inr">
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Registered</h5>
                      <h5 className="fs-sm text-primary">{registeredEvents}</h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Agendas</h5>
                      <h5 className="fs-sm text-primary">{agendaCount}</h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Feedback</h5>
                      <h5 className="fs-sm text-primary">{feedbackCount}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* contact count */}
            <div className="col-lg-3 col-sm-6 mb-3">
              <div className="report_bx bg_white p-4">
                <div className="speaker_info">
                  <h3 className="mb-3">CONTACTS</h3>
                  <div className="report_table_inr">
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Users</h5>
                      <h5 className="fs-sm text-primary">{userCount}</h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Request sent</h5>
                      <h5 className="fs-sm text-primary">{sentContactCount}</h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Request accepted</h5>
                      <h5 className="fs-sm text-primary">
                        {accpetContactCount}/{sentContactCount}
                      </h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Request Pending</h5>
                      <h5 className="fs-sm text-primary">
                        {pendingContactCount}/{sentContactCount}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* meeting count */}
            <div className="col-lg-3 col-sm-6 mb-3">
              <div className="report_bx bg_white p-4">
                <div className="speaker_info">
                  <h3 className="mb-3">MEETINGS</h3>
                  <div className="report_table_inr">
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Invitation Sent</h5>
                      <h5 className="fs-sm text-primary">{agendaSentCount}</h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">
                        Invitation Accepted
                      </h5>
                      <h5 className="fs-sm text-primary">
                        {agendaAccpetCount}/{agendaSentCount}
                      </h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Pending Response</h5>
                      <h5 className="fs-sm text-primary">
                        {agendaPendingCount}/{agendaSentCount}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* match count */}
            <div className="col-lg-3 col-sm-6 mb-3">
              <div className="report_bx bg_white p-4">
                <div className="speaker_info">
                  <h3 className="mb-3">MATCH</h3>
                  <div className="report_table_inr">
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Customer</h5>
                      <h5 className="fs-sm text-primary">
                        {agendaCustomerCount}
                      </h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Provider</h5>
                      <h5 className="fs-sm text-primary">
                        {agendaProviderCount}
                      </h5>
                    </div>
                    <div className="report_table_row d-flex align-items-center justify-content-between pb-2">
                      <h5 className="fs-sm text-primary">Partner</h5>
                      <h5 className="fs-sm text-primary">
                        {agendaPartnerCount}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* member report */}
        <div className="report_table_area mt-4">
          <table className="w-100 bg_white">
            <thead>
              <tr>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  NAME
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  EVENTS
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  CONTACTS
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  MEETINGS
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  CUSTOMERS
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  PROVIDERS
                </th>
                <th className="text-center fw-medium fs-sm text-primary text-uppercase">
                  PARTNERS
                </th>
              </tr>
            </thead>
            <tbody>
              {memberReportList.map((report, index) => {
                return (
                  <tr key={index}>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.member}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.event}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.contact}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.meeting}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.meetingcustomercount}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.meetingprovidercount}
                    </td>
                    <td className="text-center fw-medium fs-sm text-primary text-uppercase">
                      {report.meetingsuppliercount}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* load more */}
        {hideLoadMore ? (
          <div className="load_more mt-5 text-center">
            <Link to="#" className="btn disabled">
              No more report to display
            </Link>
          </div>
        ) : (
          <div className="load_more mt-5 text-center">
            <button
              className="btn primary-btn"
              disabled={memberReportLoading ? true : false}
              style={{
                cursor: memberReportLoading ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                onNextPage();
              }}
            >
              load more
              {memberReportLoading && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReportBody;
